import { FormControl, Select } from '../../../../primitives/index.js'
import { capitalize } from '@tunasong/models'
import type { FC } from 'react'
import { useController } from 'react-hook-form'
import type { EnumFormField } from '../../../lib/form-field.js'
import type { FormComponentProps } from '../form-component.js'
import styles from './enum.module.css'

export interface EnumSchemaFieldProps extends FormComponentProps<EnumFormField> {}

export const EnumSchemaField: FC<EnumSchemaFieldProps> = props => {
  const { name, spec, control } = props
  const label = capitalize(spec.metadata?.label ?? name)

  const enumValues = Array.isArray(spec.values) ? spec.values : (Object.values(spec.values) as string[])
  const enumKeys = Array.isArray(spec.values) ? spec.values.map(v => capitalize(v)) : Object.keys(spec.values)

  const { field } = useController({
    name,
    control,
  })

  return (
    <FormControl fullWidth={true} className={styles.formControl}>
      <Select label={label} {...field} value={field.value ?? ''}>
        {enumValues.map((val, idx) => (
          <option key={idx} value={val}>
            {enumKeys[idx]}
          </option>
        ))}
      </Select>
    </FormControl>
  )
}

export default EnumSchemaField
